import {DialogActions} from "@mui/material";
import styled from "styled-components";

/** Shared picker actions: touch-safe controls that stack without overflowing a phone dialog. */
export const PickerDialogActions = styled(DialogActions)`
	flex-wrap: wrap;
	gap: 8px;

	button {
		min-height: 44px;
		margin: 0;
	}

	@media (max-width: 480px) {
		align-items: stretch;
		flex-direction: column-reverse;

		button {
			width: 100%;
		}
	}
`;
